export default __webpack_public_path__ + "static/media/05.e009c0b0.png";